
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Prostate_cancer',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Prostate_cancer.vue